export function generarPdf (pdfBase64) {
  const byteCharacters = atob(pdfBase64)
  const byteNumbers = []
  for (var i = 0; i < byteCharacters.length; i++) {
    byteNumbers.push(byteCharacters.charCodeAt(i))
  }
  const file = new Blob([new Uint8Array(byteNumbers)], { type: 'application/pdf' })

  return URL.createObjectURL(file)
}

export function abrirPestanaEnBlanco () {
  const loadingUrl = '/static/baseDescargaFichero.html'
  const nuevaPestana = window.open(loadingUrl, '_blank')
  if (!nuevaPestana) return null

  return nuevaPestana
}

export function abrirPdfEnPestanaPreabierta (pdfUrl, targetWindow) {
  // Si se ha preabierto una pestana y el usuario la cierra, se cancela la apertura del PDF.
  if (targetWindow) {
    if (!targetWindow.closed) {
      targetWindow.location.href = pdfUrl
    }
    return
  }

  const link = document.createElement('a')
  link.href = pdfUrl
  link.target = '_blank'
  link.rel = 'noopener noreferrer'
  link.style.display = 'none'

  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export function downloadZip (filename, data) {
  var element = document.createElement('a')
  element.setAttribute('href', 'data:application/zip;base64,' + data)
  element.setAttribute('download', filename)

  element.style.display = 'none'
  document.body.appendChild(element)

  element.click()

  document.body.removeChild(element)
}



// WEBPACK FOOTER //
// ./src/utils/utilDescargarPdf.js